<template>
    <transition>
      <div class="floatDiv" :style="styles" v-drag="{handle}" v-drag.window-only>
        <a class="closeBtn" @mousedown="close"><b-icon icon="close-thick" style="color: white;"></b-icon></a>
        <div id="header" class="floatDiv__header" ref="drag-handle">
          <span class="floatDivTitle">{{title}}</span>
        </div>
        <div class="divContents" :style="styles">
            <slot></slot>
        </div>
      </div>
    </transition>
</template>

<script>
export default {
  name: "FloatingDiv",
  props: {
      title:{},
      top:{},
      topFixed:{default:false},
      right:{},
      width:{},
      height:{}
  },
  data() {
    return {
      handle: undefined,
    };
  },
  methods: {
    close: function() {
      this.$emit('close')
    }
  },
  computed: {
      styles(){
          let expendTop = this.topFixed ? 0 : window.scrollY;
          return {
              "--top": 100 + expendTop + 'px',
              "--right": this.right,
              "--width": this.width,
              "--height": this.height
          }
      }
  },
  mounted() {
    this.$data.handle = this.$refs.dragHandle;
  }
};
</script>

<style lang="scss">
.floatDiv {
    position: absolute;
    --top: 120px;
    --right: 50px;
    --width: 400px;
    top: var(--top);
    right: var(--right);
    width: var(--width);
    box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.8);
    background-color: #fff;
    z-index: 30;
    border-radius: 2px;
    border: 1px solid #3006f0;
}
.floatDiv__header {
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: space-between;
    background-color: rgba(0, 0, 139, 0.7);
    padding: 8px 16px;
    cursor: move;
}
.floatDivTitle {
  color: #fff;
}

.closeBtn {
    position: absolute;
    top:10px;
    right: 10px;
}
.divContents {
    margin: 5px 8px 5px;
    --height: 500px;
    height: var(--height);
    overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/common/FloatingDiv.vue